export default __webpack_public_path__ + "static/media/fanhunter.d0772e21.jpg";